import { createAction, props } from '@ngrx/store';
import { ITransactionResponse } from '../models/transactions.model';

export const loadTransactionsPending = createAction('[TransactionsPending] Load TransactionsPending', props<{ customerId: string }>());

export const loadTransactionsPendingSuccess = createAction(
  '[TransactionsPending] Load TransactionsPending Success',
  props<{ response: ITransactionResponse[] }>()
);

export const loadTransactionsPendingFailure = createAction(
  '[TransactionsPending] Load TransactionsPending Failure',
  props<{ error: Error | any }>()
);
